// Local reflective snippet library — used for GUIDED (non-AI) readings so the
// ritual never breaks. Mirrors the backend library.
export const LINE_LIBRARY = [
  {
    key: "heart",
    title: "Heart Line",
    subtitle: "How warmth is given and received",
    snippets: [
      "The heart line invites you to consider how you give and receive warmth. Notice where it runs deep and where it softens.",
      "Where this line curves upward, it may invite reflection on openness — a willingness to let feeling lead.",
      "A branching heart line can be an invitation to explore the many ways connection shows up in a life.",
      "Consider the space this line holds — an invitation to notice how you tend to the tender parts of yourself.",
    ],
  },
  {
    key: "head",
    title: "Head Line",
    subtitle: "How meaning is made",
    snippets: [
      "The head line invites curiosity about how you make meaning — through logic, intuition, or a weave of both.",
      "Notice its length: a longer arc may invite reflection on thoroughness, a shorter one on decisiveness.",
      "Where the head line meets the life line, consider the quiet dialogue between thought and action.",
      "A gently sloping head line can invite reflection on imagination and the pull of the unseen.",
    ],
  },
  {
    key: "life",
    title: "Life Line",
    subtitle: "Vitality and rootedness",
    snippets: [
      "The life line is not about length of days — it invites reflection on vitality, rootedness, and how you move through the world.",
      "A wide arc may invite you to consider your appetite for experience and open space.",
      "Islands or breaks here are simply invitations to notice seasons of change and renewal.",
      "Where this line runs close to the thumb, consider what home and steadiness mean to you now.",
    ],
  },
  {
    key: "fate",
    title: "Fate Line",
    subtitle: "Threads of purpose and direction",
    snippets: [
      "The fate line invites reflection on the threads of purpose and direction you feel drawn toward.",
      "Where it runs faint, consider the freedom of an unwritten path.",
      "A strong fate line can be an invitation to notice the structures that support your sense of meaning.",
      "Breaks along this line may invite reflection on the pivots that reshaped your course.",
    ],
  },
];

export function offlineReadingLines() {
  return LINE_LIBRARY.map((l) => ({
    key: l.key,
    title: l.title,
    subtitle: l.subtitle,
    note: l.snippets[0],
    options: l.snippets,
    present: true,
  }));
}

export const COUPLES_COMPATIBILITY =
  "Placing two hands side by side is an invitation to notice resonance — where lines echo one another and where they offer contrast.";

// Guided (non-AI) markings — the witch mark can't be detected offline, so we
// frame it as a "quiet ember" (mirrors the backend absent copy).
export function offlineMarkings() {
  return {
    witch: {
      present: false,
      confidence: "none",
      title: "A Quiet Ember",
      subtitle: "The Mystic Cross · not yet drawn",
      text:
        "No distinct cross in the center of your palm today — and that's its own kind of message. The intuition the witch's mark names isn't absent in you; it simply hasn't etched itself into the hand. Marks like these are known to deepen and appear over a lifetime. Yours may be an ember, not yet a flame.",
    },
    gifts: [],
  };
}
